import { render } from "./inventory-progress-bar.vue?vue&type=template&id=0c05a07f"
import script from "./inventory-progress-bar.vue?vue&type=script&lang=js"
export * from "./inventory-progress-bar.vue?vue&type=script&lang=js"

import "./inventory-progress-bar.vue?vue&type=style&index=0&id=0c05a07f&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__